import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=2996c183&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"
import style0 from "./Admins.vue?vue&type=style&index=0&id=2996c183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996c183",
  null
  
)

export default component.exports